export const dateWithDots = x => x.toString().replace(/-/g, '.');
